// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2diBF","buttons":"SendReceipts_buttons__34K2K","email":"SendReceipts_email__2sBzF","bookApptTitle":"SendReceipts_bookApptTitle__3kjrU"};